// extracted by mini-css-extract-plugin
export default {"hideTooltip":"f_-z","fadeIn":"g_-z","delay":"h_-z","recommendedSizeTooltip":"i_-z"};